import { render, staticRenderFns } from "./SendSolution.vue?vue&type=template&id=6ff3b03c&scoped=true&"
import script from "./SendSolution.vue?vue&type=script&lang=ts&"
export * from "./SendSolution.vue?vue&type=script&lang=ts&"
import style0 from "./SendSolution.vue?vue&type=style&index=0&id=6ff3b03c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff3b03c",
  null
  
)

export default component.exports